import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
  Button,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import { useDispatch } from "react-redux";
import { setContactState } from "../../../redux/actions/contactAction";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Swal from "sweetalert2";

const AddContact = ({resetValue}) => {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const customId1 = "custom-id-yess";
  const dispatch = useDispatch();
  const [emailchange, setemailChange] = useState("");
  const [description, setdescription] = useState("");
  const [RelodPhoneBookList, setRelodPhoneBookList] = useState(true);
  const [open, setOpen] = useState();
  const [file, setFile] = useState("");
  const [changeState, setchangeState] = useState(false);
  const [data, setData] = useState([]);
  const [arrayvalue, setArrayValue] = useState(null);
  const [ContactArray, SetContactArray] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [error, seterror] = useState(false);

// console.log("first",arrayvalue)
  // --------------------------------------Table-----------------------------
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const columns = useMemo(
    () => [
      {
        Header: "Contact Name",
        accessor: "contactName", // accessor is the "key" in the data
      },

      // {
      //   Header: "Email Id",
      //   accessor: "emailId",
      // },
      {
        Header: "Mobile Number",
        accessor: "mobileNumber", // accessor is the "key" in the data
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };
  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  // ------------------------------------End Table-------------------------------
  function handleChange(event) {
    setFile(event.target.files[0]);
  }
  function handleChange1(event) {
    setArrayValue(event.target.value);
  }
  //.....................................Formik............................................//
  const initialValues = {
    contactName: "",
    mobileNumber: "",
    // emailId: "",
    // description:""
  };
  const validationSchema = yup.object({
    mobileNumber: yup
    .string()
    .min(8, "Minimum length of a mobile number is 8 digits")
    .max(8, "Maximum length of mobile number is 8 digits")
   .required("Required"),
    contactName: yup
      .string()
      .min(3, "Please enter atleast 3 characters in name")
      .max(90, "No more longer to 20 charcaters")
      .required("Required"),
    description: yup
      .string()
      .min(3, "Please enter atleast 3 characters in description")
      .max(90, "No more longer to 90 charcaters"),
    // .required("Required"),
    emailId: yup.string().email("E-Mail must be valid").max(255),
    // .required("E-Mail  is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      ContactPost(values);
    },
  });
  async function ContactGet(values) {
    try {
      setHideSkeleton(true);
      let res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);
        const mapp = res.data.listOfPlaysmsPhonebook.map(
          (x) => x.phonebookDescription
        );
        if (!mapp.includes("Default")) {
          const obj = {
            id: 1,
            phonebookName: "Default",
          };
          res.data.listOfPlaysmsPhonebook.push(obj);
        }
        SetContactArray(res.data.listOfPlaysmsPhonebook);
      } else {
        // setOpen(false);
        setHideSkeleton(false);
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton(false);
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  async function ContactPost(values) {
    try {
      setOpen(true);
      if (arrayvalue == "1") {
        // alert("hii")
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/contacts/create`,
          {
            contactName: values.contactName,
            mobileNumber: values.mobileNumber,
            description: description,
            emailId: emailchange,
            phoneBookId: arrayvalue?.id,
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setOpen(false);
          ContactGet();

          setArrayValue("!");
          await setData([
            ...data,
            {
              contactName: values.contactName,
              mobileNumber: "222"+values.mobileNumber,
              emailId: values.emailId,
            },
          ]);
          // FilterGet();
          formik.handleReset();
          setdescription("");
          setemailChange("");
          setRelodPhoneBookList(!RelodPhoneBookList);
          dispatch(setContactState(RelodPhoneBookList));
          setArrayValue(null);
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Contact Added successfully!!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setchangeState(!changeState);
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
             title: "Oops...",
            text:res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/contacts/create`,
          {
            contactName: values.contactName,
            mobileNumber: "222"+values.mobileNumber,
            description: description,
            emailId: emailchange,
            phoneBookId: arrayvalue?.id,
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setOpen(false);
          setRelodPhoneBookList(!RelodPhoneBookList);
          dispatch(setContactState(RelodPhoneBookList));
          ContactGet();
          await setData([
            ...data,
            {
              contactName: values.contactName,
              mobileNumber: values.mobileNumber,
              emailId: values.emailId,
            },
          ]);
          // FilterGet();
          formik.handleReset();
          setArrayValue();
          setdescription("");
          setemailChange("");
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Contact Added successfully!!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setchangeState(!changeState);
        } else {
          setOpen(false);
            Swal.fire({
            icon: "error",
             title: "Oops...",
            text:res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
        Swal.fire({
            icon: "error",
             title: "Oops...",
            text:"Please Check Your Network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
    }
  }
  useEffect(() => {
    ContactGet();
  }, []);
  const resetbutton = () => {
    setdescription("");
    setemailChange("");
    setArrayValue(null)
  };
  useEffect(() => {
    formik.handleReset();
    setdescription("");
    setemailChange("");
    setArrayValue(null)
  }, [resetValue]);
  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div className="card-body">
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              {/* Add Number */}
              Add Contact
            </span>
            <div className="card-body text-lg-start text-center">
              <section class="right_panel px-0">
                <div class="container-fluid_1">
                  <div class="tab-content" id="pills-tabContent">
                    <ThemeProvider theme={theme}>
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <form
                          onSubmit={formik.handleSubmit}
                          role="form"
                          className="text-start"
                        >
                          <div class="">
                            <div class="row">
                              {/* <div class="col-md-4">
                                <TextField
                                  className=" w-100"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  type="number"
                                  label="Mobile Number"
                                  name="mobileNumber"
                                  variant="outlined"
                                  size="small"
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="Mobile Number"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={formik.handleChange}
                                  value={formik.values.mobileNumber}
                                  error={
                                    formik.touched.mobileNumber &&
                                    Boolean(formik.errors.mobileNumber)
                                  }
                                  helperText={
                                    formik.touched.mobileNumber &&
                                    formik.errors.mobileNumber
                                  }
                                />
                              </div> */}

                              <div className="col-md-4" id="inp_merge">
                      <div className="d-flex">
                      <input className="inpt_width"
  disabled
  value="+222"
/>
                        <TextField
                          required
                          className="w-100"
                          label="Mobile Number"
                          name="mobileNumber"
                          variant="outlined"
                          size="small"
                          type="string"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="Mobile Number"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.mobileNumber}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.mobileNumber &&
                            Boolean(formik.errors.mobileNumber)
                          }
                          helperText={
                            formik.touched.mobileNumber &&
                            formik.errors.mobileNumber
                          }
                          onInput={(e) => {
                          // e.target.value = Math.max(0, parseInt(e.target.value))
                          //   .toString()
                          //   .slice(0, 8);
                          e.target.value = e.target.value.slice(0, 8);
                        }}

                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;

                          if (
                            (keyCode >= 48 && keyCode <= 57) ||
                            keyCode == 13
                          ) {
                            seterror(false);
                          } else {
                            event.preventDefault();
                            seterror(true);
                          }
                        }}
                          // inputProps={{ maxLength: 9999999999 }}
                        />
                        </div>

                        <div className="row">
                    {error == true ? (
                      <>
                        <p style={{ color: "red" }}>
                          Only Numbers Are Allowed!!
                        </p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                      </div>
                              <div class="col-md-4">
                                <TextField
                                  className=" w-100"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Contact Name"
                                  name="contactName"
                                  variant="outlined"
                                  size="small"
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="Contact Name"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={formik.handleChange}
                                  value={formik.values.contactName}
                                  error={
                                    formik.touched.contactName &&
                                    Boolean(formik.errors.contactName)
                                  }
                                  helperText={
                                    formik.touched.contactName &&
                                    formik.errors.contactName
                                  }
                                />
                              </div>
                              <div class="col-md-4">
                                <TextField
                                  // required
                                  className="w-100"
                                  label="E-mail"
                                  name="emailId"
                                  variant="outlined"
                                  type="email"
                                  size="small"
                                  autoFocus
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="E-mail"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={emailchange}
                                  onChange={(event) => {
                                    setemailChange(event.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div class="row mnt_1 mt-3">
                            <div class="col-md-4">
                                <TextareaAutosize
                                  //  disabled
                                  className={
                                    formik.errors.message
                                      ? "border-color-red w-100 pt-2"
                                      : "w-100  textarea_8 pt-2"
                                  }
                                  textarea_8
                                  aria-label="empty textarea"
                                  placeholder="  Enter Description"
                                  name="description"
                                  style={{
                                    width: " 700px",
                                     minHeight: "100%",
                                    height:"100%",
                                    borderColor: "rgb(0 0 0 / 21%)",
                                    backgroundColor: "transparent",
                                    borderRadius: "4px",
                                  }}
                                  maxlength="100"
                                  // required
                                  value={description}
                                  onChange={(event) => {
                                    setdescription(event.target.value);
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                {hideSkeleton == true ? (
                                  <>
                                    {" "}
                                    <Box sx={{ width:"100%"}}>
                                      <Skeleton />
                                      <Skeleton animation="wave" />
                                      {/* <Skeleton animation={false} /> */}
                                    </Box>
                                  </>
                                ) : (
                                  <>
                                    <Autocomplete
                                      disablePortal
                                      aria-required
                                      className="w-100"
                                      id="combo-box-demo"
                                      size="small"
                                      options={ContactArray}
                                      getOptionLabel={(option) =>
                                        option.phonebookName
                                      }
                                      value={arrayvalue}
                                      // onChange={(e, value) => handlechange(value)}
                                      onChange={(e, value) => {
                                        setArrayValue(value);
                                      }}
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          required
                                          {...params}
                                          label="Add To Phonebook List"
                                        />
                                      )}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between mt-3">

                          <button
                              // onClick={formik.resetForm}
                              onClick={() => {
                                resetbutton();
                                formik.resetForm();
                              }}
                              type="button"
                              className="btn resetBtn_UP ms-2 w_btn btn_w8 m-0"
                              // onClick={Reset}
                            >
                              Reset
                             
                            </button>

                            <button
                              type="submit"
                              class="btn green_UP text-capitalize d-block  m-0"
                            >
                              save
                            </button>
                            
                          </div>
                        </form>
                      </div>
                    </ThemeProvider>
                  </div>
                </div>
              </section>
            </div>
          </div>
          {/* ------------------------------------Table------------------------------- */}
          {data.length > 0 && (
            <>
              <div>
                <div className="card shadow-none border bg_blue mt-5">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Add Contact List
                  </span>
                  <div className="card-body text-lg-start text-center">
                    <div>
                      {selectedFlatRows.length > 0 && (
                        <button onClick={deletUser}>Delete Users</button>
                      )}
                    </div>
                    <table
                      {...getTableProps()}
                      id="example"
                      className="table table-striped table-bordered dataTable table-sm"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className="text-center width_2"
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    className="text-center"
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
};
export default AddContact;
